module.exports = __webpack_public_path__ + "img/wodemaidan.bf6b8a25.png";